import { spacer4, spacer16 } from '@spotify-internal/encore-foundation';
import styled, { css } from 'styled-components';
import { IconChartDown } from "../Icon/IconChartDown";
export var TableSortIconElement = styled(IconChartDown).withConfig({
  displayName: "TableSortIcon__TableSortIconElement",
  componentId: "sc-1c0qz1q-0"
})(["block-size:", ";inline-size:", ";margin-block-start:-", ";margin-block-end:-", ";margin-inline-start:", ";margin-inline-end:", ";", ";"], spacer16, spacer16, spacer4, spacer4, spacer4, spacer4, function (props) {
  return props.direction === 'up' && css(["transform:rotate(180deg);margin-block-end:-5px;"]);
});